module.exports = __webpack_public_path__ + "static/media/IMG_027.ff35657a.JPG";